module.exports = __webpack_public_path__ + "static/media/snapshot.acc65c96.svg";